import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogoDeConfirmacao',
  props: {
    titulo: null,
    mensagem: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	titulo?: string,
	mensagem?: string,
};



const mostra = ref(false)
const titulo = ref(props.titulo || 'Confirmação')
const mensagem = ref(props.mensagem || 'Tem certeza que deseja continuar?')

const resolver = ref<((value: boolean) => void) | null>(null)

const confirmar = () => {
  mostra.value = false
  resolver.value?.(true)
}

const cancelar = () => {
  mostra.value = false
  resolver.value?.(false)
}

const abrir = (config: { titulo?: string; mensagem?: string } = {}) => {
  if (config.titulo) titulo.value = config.titulo
  if (config.mensagem) mensagem.value = config.mensagem

  mostra.value = true

  return new Promise<boolean>((resolve) => {
    resolver.value = resolve
  })
}

expose({ abrir })

return { __sfc: true,props, mostra, titulo, mensagem, resolver, confirmar, cancelar, abrir }
}

})